// extracted by mini-css-extract-plugin
export default {"answer":"Answer_answer__sihm3"};